<template>
  <b-form-group
    :class="[
      'transition-input',
      'select-input',
      value !== null && value !== void 0 && 'active',
      disabled && 'disabled',
      error && 'error',
    ]"
    :label="label"
    :label-for="id"
  >
    <div class="input-wrapper">
      <b-form-select
        :id="id"
        :options="selectOptions"
        :disabled="disabled"
        :required="required"
        :value="value"
        :class="icon && 'has-icon'"
        @change="onChange"
        @blur.native="$emit('blur')"
      />
      <FontIcon v-if="icon" :name="icon" class="select-icon" />
    </div>
    <InputError :error="error" />
  </b-form-group>
</template>

<style lang="scss">
.select-input {
  position: relative;

  .input-wrapper {
    position: relative;
  }

  select.has-icon {
    background: none;
  }

  .select-icon {
    position: absolute;
    right: rem(14px);
    top: 50%;
    transform: translateY(-50%);
    @include setColor(--color-icon1);
    font-size: rem(20px);
  }
}
</style>

<script>
import InputError from "../InputError";
import FontIcon from "../../FontIcon";

export default {
  components: {
    FontIcon,
    InputError,
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    value: {
      type: [String, Number, Object],
      required: false,
    },
    placeholder: {
      type: String,
      default: "",
    },
    error: {
      type: String,
      required: false,
    },
    options: {
      type: [Array, Object],
      default: () => [],
    },
    required: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
  },

  computed: {
    selectOptions() {
      if (!this.placeholder) {
        return this.options;
      }

      // Append placeholder to options
      const placeholder = {
        value: null,
        text: this.placeholder,
        disabled: true,
      };

      if (Array.isArray(this.options)) {
        return [placeholder].concat(this.options);
      }

      return [
        placeholder,
        ...Object.entries(this.options).map(([value, text]) => ({
          value,
          text,
        })),
      ];
    },
  },

  methods: {
    onChange(value) {
      this.$emit("update:value", value);
    },
  },
};
</script>
